import React, { createContext, useContext } from "react";
import { message } from "antd";

interface NotificationContextType {
  showSuccess: (content: string) => void;
  showError: (content: string) => void;
  showInfo: (content: string) => void;
  showWarning: (content: string) => void;
}

const NotificationContext = createContext<NotificationContextType | undefined>(
  undefined
);

export const NotificationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [messageApi, contextHolder] = message.useMessage();

  const showSuccess = (content: string) => {
    messageApi.success(content);
  };

  const showError = (content: string) => {
    messageApi.error(content);
  };

  const showInfo = (content: string) => {
    messageApi.info(content);
  };

  const showWarning = (content: string) => {
    messageApi.warning(content);
  };

  return (
    <NotificationContext.Provider
      value={{
        showSuccess,
        showError,
        showInfo,
        showWarning,
      }}
    >
      {contextHolder}
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotification = () => {
  const context = useContext(NotificationContext);
  if (context === undefined) {
    throw new Error(
      "useNotification must be used within a NotificationProvider"
    );
  }
  return context;
};
